/**
 * Machine-translation disclaimer for legal pages.
 * Renders ONLY when the active locale is not English.
 * Tells users the English version is the legally binding original.
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import './MachineTranslationNotice.css';

export const MachineTranslationNotice = () => {
  const { i18n, t } = useTranslation();
  const lang = (i18n.language || 'en').split('-')[0];
  if (lang === 'en') return null;

  return (
    <div className="mt-notice" data-testid="machine-translation-notice" role="note">
      <span className="mt-icon" aria-hidden>⚠️</span>
      <p className="mt-body">{t('legal.machine_translation_notice')}</p>
      <button
        className="mt-en-btn"
        onClick={() => i18n.changeLanguage('en')}
        data-testid="machine-translation-switch-en"
      >
        English
      </button>
    </div>
  );
};

export default MachineTranslationNotice;
